import Stack from "@mui/material/Stack";
import React from "react";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
export default function ProductCommissionFormRow({
  item,
  index,
  handleProductCommissionForm,
  productCommissionValidation,
  productOptions,
  disabled,
  copyProductCommissionFormData,
  removeProductCommissionFormData,
  currentDate,
}) {
  const productBonusFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={2}
        >
          {item.isDisabled && (
            <SubdirectoryArrowRightIcon color="warning"></SubdirectoryArrowRightIcon>
          )}
          <TextField
            disabled={disabled}
            error={!!productCommissionValidation[index]?.nameErr}
            helperText={productCommissionValidation[index]?.nameErr}
            sx={{ maxWidth: 200, minWidth: 200, flex: 0.5 }}
            value={item.name}
            id="outlined-basic"
            label="名稱"
            onChange={(event) => {
              handleProductCommissionForm(index, "name", event.target.value);
            }}
            variant="outlined"
          />
          <FormControl fullWidth>
            <DatePicker
              disabled={item.isDisabled || disabled}
              id="startDate"
              name="startDate"
              label="開始日期"
              minDate={moment(currentDate)
                .startOf("month")
                .format("YYYY-MM-DD")}
              maxDate={moment(currentDate).endOf("month").format("YYYY-MM-DD")}
              value={item.startDate}
              onChange={(value) => {
                handleProductCommissionForm(
                  index,
                  "startDate",
                  moment(value).format("YYYY-MM-DD")
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ width: "100%" }}
                  error={!!productCommissionValidation[index]?.startDateErr}
                />
              )}
            ></DatePicker>
            <FormHelperText
              error={!!productCommissionValidation[index]?.startDateErr}
            >
              {productCommissionValidation[index]?.startDateErr}
            </FormHelperText>
          </FormControl>
          <FormControl fullWidth>
            <DatePicker
              disabled={item.isDisabled || disabled}
              id="startDate"
              name="startDate"
              label="結束日期"
              minDate={moment(currentDate)
                .startOf("month")
                .format("YYYY-MM-DD")}
              maxDate={moment(currentDate).endOf("month").format("YYYY-MM-DD")}
              value={item.endDate ?? moment(currentDate).endOf("month")}
              onChange={(value) => {
                handleProductCommissionForm(
                  index,
                  "endDate",
                  moment(value).format("YYYY-MM-DD")
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ width: "100%" }}
                  error={!!productCommissionValidation[index]?.endDateErr}
                />
              )}
            ></DatePicker>
            <FormHelperText
              error={!!productCommissionValidation[index]?.endDateErr}
            >
              {productCommissionValidation[index]?.endDateErr}
            </FormHelperText>
          </FormControl>
        </Stack>
        <ProductAutoComplete
          multiple
          disabled={item.isDisabled}
          sx={{ width: 150, flex: 7 }}
          productOptions={productOptions}
          handleOnChange={(value) => {
            handleProductCommissionForm(index, "productIds", value);
          }}
          selectedValue={item.productIds ?? []}
          error={!!productCommissionValidation[index]?.productIdsErr}
        ></ProductAutoComplete>

        <TextField
          disabled={disabled}
          error={!!productCommissionValidation[index]?.minQtyErr}
          helperText={productCommissionValidation[index]?.minQtyErr}
          sx={{ maxWidth: 110, minWidth: 110, flex: 0.5 }}
          value={item.minQty}
          type="number"
          id="outlined-basic"
          label="最少目標數量"
          onChange={(event) => {
            handleProductCommissionForm(index, "minQty", event.target.value);
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            endAdornment: <InputAdornment position="end">件</InputAdornment>,
          }}
        />
        <TextField
          disabled={disabled}
          error={!!productCommissionValidation[index]?.maxQtyErr}
          helperText={productCommissionValidation[index]?.maxQtyErr}
          sx={{ maxWidth: 110, minWidth: 110, flex: 0.5 }}
          value={item.maxQty}
          type="number"
          id="outlined-basic"
          label="最多目標數量"
          onChange={(event) => {
            handleProductCommissionForm(index, "maxQty", event.target.value);
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            endAdornment: <InputAdornment position="end">件</InputAdornment>,
          }}
        />
        <TextField
          disabled={disabled}
          error={!!productCommissionValidation[index]?.commissionErr}
          helperText={productCommissionValidation[index]?.commissionErr}
          sx={{ maxWidth: 180, minWidth: 100, flex: 0.5 }}
          value={item.commission}
          type="number"
          id="outlined-basic"
          label="每盒佣金"
          onChange={(event) => {
            handleProductCommissionForm(
              index,
              "commission",
              parseFloat(event.target.value)
            );
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <FormControl sx={{ flex: 1.5, alignSelf: "center" }}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={item.isDisabled || disabled}
                sx={{ p: 0 }}
                color="success"
                checked={item.excludeCommission}
                onChange={(_, value) => {
                  handleProductCommissionForm(
                    index,
                    "excludeCommission",
                    value
                  );
                }}
              />
            }
            label={
              <Typography variant="body2" color="textSecondary">
                不計入佣金
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                disabled={item.isDisabled || disabled}
                sx={{ p: 0 }}
                color="success"
                checked={item.isDirectSales}
                onChange={(_, value) => {
                  handleProductCommissionForm(index, "isDirectSales", value);
                }}
              />
            }
            label={
              <Typography variant="body2" color="textSecondary">
                Direct Sales
              </Typography>
            }
          />
        </FormControl>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton
              onClick={() => copyProductCommissionFormData(item, index)}
            >
              <ContentCopyIcon></ContentCopyIcon>
            </IconButton>
            <IconButton
              color="error"
              onClick={() => removeProductCommissionFormData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeProductCommissionFormData]
  );

  return productBonusFormRow;
}
